<script>
export default {
  name: 'Portal',
  props: {
    target: {
      type: String,
      default: 'body'
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      targetElement: null,
      hasMovedToTarget: false
    }
  },
  mounted () {
    if (!this.disabled) {
      this.targetElement = document.querySelector(this.target) || document.body
      this.moveToTarget()
    }
  },
  updated () {
    // Only move if we haven't moved to target yet or if disabled state changed
    // This prevents unnecessary DOM moves that can disrupt focus on Safari mobile
    if (!this.disabled && !this.hasMovedToTarget) {
      this.moveToTarget()
    }
  },
  beforeDestroy () {
    if (this.$el && this.$el.parentNode) {
      this.$el.parentNode.removeChild(this.$el)
    }
  },
  watch: {
    disabled (newValue) {
      if (newValue) {
        // Move back to original position
        if (this.$el && this.$el.parentNode && this.hasMovedToTarget) {
          // Preserve focus before moving
          const activeElement = document.activeElement
          const shouldRestoreFocus = this.$el.contains(activeElement)
          
          this.$parent.$el.appendChild(this.$el)
          this.hasMovedToTarget = false
          
          // Restore focus after move
          if (shouldRestoreFocus && activeElement) {
            this.$nextTick(() => {
              activeElement.focus()
            })
          }
        }
      } else {
        // Move to portal target
        this.targetElement = document.querySelector(this.target) || document.body
        this.moveToTarget()
      }
    }
  },
  methods: {
    moveToTarget () {
      if (this.targetElement && this.$el && !this.disabled && !this.hasMovedToTarget) {
        // Preserve focus before moving
        const activeElement = document.activeElement
        const shouldRestoreFocus = this.$el.contains(activeElement)
        
        this.targetElement.appendChild(this.$el)
        this.hasMovedToTarget = true
        
        // Restore focus after move on next tick
        if (shouldRestoreFocus && activeElement) {
          this.$nextTick(() => {
            activeElement.focus()
          })
        }
      }
    }
  },
  render (h) {
    return h('div', {
      class: 'portal-wrapper'
    }, this.$slots.default)
  }
}
</script> 